import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/system";

// Styled footer container
const FooterContainer = styled(Box)({
  position: "fixed",
  bottom: 0,
  width: "100%",
  backgroundColor: "#002147", // Dark navy blue
  color: "#ffffff",
  textAlign: "center",
  padding: "10px 0",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  fontFamily: "'Gotham Light', 'Avenir Next Light', sans-serif",
  zIndex: 1000,
});

// Footer Component
const Footer = () => {
  return (
    <FooterContainer>
      {/* Use public folder reference */}
      <img
        src="/skyvera_logo.jpg"
        alt="Skyvera Logo"
        style={{ height: "30px", marginRight: "10px" }}
      />
      <Typography variant="body1">
        Powered by BSS Magic
      </Typography>
    </FooterContainer>
  );
};

export default Footer;
